import Account from './Account';
import { UserIsAuthenticated, siteTitle } from '../';

const AccountRoutes = {
    account: {
        path: '/Account/',
        label: 'Account',
        title: `${siteTitle} - Account`,
        component: UserIsAuthenticated(Account)
    }
};

export { AccountRoutes, Account };



// WEBPACK FOOTER //
// ./src/app/containers/Account/index.ts